import './index.scss';
import { useHistory } from 'react-router';
import { userInfo } from '../../../redux/slice';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

export default TaxSummary; function TaxSummary({ Eligible, NotEligibleReason }) {
    const history = useHistory();
    const user = useSelector(userInfo);
    const { t } = useTranslation();

    const goto = async => {
        let url = '';
        if (user?.sfUserType === 'IR') {
            url = '/preview/questionnaires';
        }
        else {
            url = '/questionnaires';
        }

        history.push({
            pathname: url
        });
    }
    return (<>
        <div id='tax-summary'>
            {
                Eligible ? (<>
                    <svg width="158" height="159" viewBox="0 0 158 159" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M78.9994 13.9062C42.6984 13.9062 13.166 43.4387 13.166 79.7396C13.166 116.04 42.6984 145.573 78.9994 145.573C115.3 145.573 144.833 116.04 144.833 79.7396C144.833 43.4387 115.3 13.9062 78.9994 13.9062Z" fill="#007F50" fill-opacity="0.23" />
                        <path d="M113.438 56.526C111.278 54.2339 107.678 54.1329 105.397 56.3122L69.0833 90.9749L51.7627 73.0758C49.569 70.8104 45.9722 70.7608 43.7196 72.969C41.4689 75.1751 41.4215 78.7991 43.6133 81.0645L64.8494 103.009C65.9623 104.16 67.4413 104.74 68.9241 104.74C70.331 104.74 71.738 104.217 72.8396 103.17L113.226 64.6198C115.505 62.4441 115.601 58.82 113.438 56.526Z" fill="#007F50" />
                    </svg>

                    <div className='row'>
                        <span className='notice notice-2'>
                            {t('THANK YOU')}
                        </span>
                    </div>

                    <div className='row'>
                        <span className='desc'>
                            {t('You have successfully submitted the TaxYear Tax Questionnaire form.').replaceAll('{taxYear}', sessionStorage.getItem('taxYear'))}
                        </span>
                    </div>
                </>) : (<>
                    <div className='row'>
                        <svg width="100" height="100" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M34.5626 18.644C39.0289 12.9711 43.7602 9.36719 50.0025 9.36719C56.2448 9.36719 60.9761 12.971 65.4424 18.644C69.835 24.2233 74.4899 32.4767 80.4456 43.0365L82.2599 46.2533C87.1833 54.9823 91.0718 61.8767 93.1144 67.4104C95.2017 73.0655 95.6975 78.2002 92.54 82.7294C89.4759 87.1245 84.3636 88.9229 77.9157 89.7717C71.4924 90.6173 62.8545 90.6172 51.7725 90.6172H48.2325C37.1505 90.6172 28.5126 90.6173 22.0893 89.7717C15.6414 88.9229 10.5291 87.1245 7.46506 82.7294C4.30752 78.2002 4.80337 73.0655 6.89067 67.4104C8.93318 61.8767 12.8217 54.9824 17.745 46.2534L19.5593 43.0367C25.5151 32.4768 30.17 24.2233 34.5626 18.644ZM39.4733 22.5102C35.4149 27.665 30.9903 35.4917 24.8566 46.3669L23.3413 49.0535C18.232 58.1124 14.6013 64.5699 12.754 69.5746C10.9305 74.515 11.1833 77.1343 12.5921 79.1551C14.0944 81.3099 16.914 82.7865 22.9051 83.5752C28.8717 84.3606 37.0968 84.3672 48.4872 84.3672H51.5178C62.9082 84.3672 71.1333 84.3606 77.1 83.5752C83.091 82.7865 85.9107 81.3099 87.4129 79.1551C88.8217 77.1343 89.0745 74.515 87.251 69.5746C85.4037 64.5699 81.773 58.1123 76.6637 49.0535L75.1484 46.3669C69.0147 35.4916 64.5901 27.665 60.5317 22.5102C56.511 17.4032 53.3883 15.6172 50.0025 15.6172C46.6167 15.6172 43.494 17.4032 39.4733 22.5102Z" fill="#E3401E" />
                            <path d="M49.9987 30.2109C51.7246 30.2109 53.1237 31.61 53.1237 33.3359V54.1693C53.1237 55.8952 51.7246 57.2943 49.9987 57.2943C48.2728 57.2943 46.8737 55.8952 46.8737 54.1693V33.3359C46.8737 31.61 48.2728 30.2109 49.9987 30.2109Z" fill="#E3401E" />
                            <path d="M49.9987 70.8359C52.2999 70.8359 54.1654 68.9705 54.1654 66.6693C54.1654 64.3681 52.2999 62.5026 49.9987 62.5026C47.6975 62.5026 45.832 64.3681 45.832 66.6693C45.832 68.9705 47.6975 70.8359 49.9987 70.8359Z" fill="#E3401E" />
                        </svg>
                    </div>

                    <div className='row'>
                        <span className='notice'>
                            {(() => {
                                switch (NotEligibleReason) {
                                    case 'OtherSourceOfIncome':
                                        return (<>{t('Notice_OtherSourceOfIncome')}</>)
                                    case 'TravelHistory':
                                    case 'USResident':
                                        return (<>{t('Notice_US_Tax_Resident')}</>)
                                    default:
                                        return (<>{t('Notice_US_Tax_Resident')}</>)
                                }
                            })()}
                        </span>
                    </div>
                    {(() => {
                        switch (NotEligibleReason) {
                            case 'OtherSourceOfIncome':
                                return (<>
                                    <div className='row'>
                                        <span className='desc'>
                                            {t('You are not eligible to proceed with AAS tax filing service since the service only applies to Non-U.S Citizen/Resident clients who have U.S. income from Walton land investment solely.')}
                                        </span>
                                    </div >
                                </>)
                            case 'TravelHistory':
                                return (<>
                                    <div className='row'>
                                        <span className='desc'>
                                            {t('Based on your travel history, you meet the IRS Substantial Presence Test and are considered a U.S. tax resident for the applicable tax year.')}
                                        </span>
                                    </div >
                                </>)
                            case 'USResident':
                                return (<>
                                    <div className='row'>
                                        <span className='desc'>
                                            {t('You are not eligible to proceed with AAS services, which are for non-U.S. tax residents only.')}
                                        </span>
                                    </div >
                                </>)
                            default:
                                return (<>
                                    <div className='row'>
                                        <span className='desc'>
                                            {t('You are not eligible to proceed with AAS services, which are for non-U.S. tax residents only.')}
                                        </span>
                                    </div >
                                </>)
                        }
                    })()}
                </>)
            }

            <div className='row button'>
                <button onClick={() => goto()}>
                    {t('OK')}
                </button>
            </div>
        </div >
    </>);
}